module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title",
    attrs: {
      "id": "title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("Catching"), _c('br'), _vm._v("the"), _c('br'), _vm._v("Catfishers")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("Disarm the Online Pretenders,"), _c('br'), _vm._v("Predators, and Perpetrators"), _c('br'), _vm._v("Who Are Out to Ruin Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "titlea"
  }, [_vm._v("Tyler Cohen Wood")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 63
// module chunks = 0